export default __webpack_public_path__ + "static/media/yeezy4.a7c6875a.jpg";